import { createAction, props } from '@ngrx/store';

export const seSignOtpSmsRequest = createAction(
    '[SeSign] OtpSmsRequest',
    props<{ signerId: string; signerCode: string; password: string }>(),
);

export const seSignOtpSmsReset = createAction('[SeSign] OtpSmsReset');

export const seSignOtpSmsSuccess = createAction('[SeSign] OtpSmsSuccess');

export const seSignOtpSmsError = createAction('[SeSign] OtpSmsError', props<{ message: string }>());
